import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import content from '../../assets/content.json';
import { isCardInCollection } from '../../stored/Collection';
import './TipBubble.sass';

const INVISIBLE_TIME = 5 * 1000;
const READING_TIME = 8 * 1000;

const getTips = () => {
	const { tips } = content.strings.scan;
	const filteredTips = [];

	tips.forEach(tip => {
		let tipAdded = false;
		if (!tipAdded) tip.cards.forEach((card) => {
			if (!isCardInCollection(card)) {
				filteredTips.push(tip.tip);
				tipAdded = true;
			}
		});
	});

	return filteredTips;
}

const TipBubble = ({ children, className, animated, soundEnabled }) => {

	const [tipText, setTipText] = useState(null);

	useEffect(() => {
		if (!children) {
			const interval = setInterval(() => {
				if (tipText == null && soundEnabled && !document.hidden) {
					// @ts-ignore
					window.playSound(`tip_${Math.floor(Math.random() * 4) + 1}`, 0.6);
				}
				const tips = getTips();
				setTipText(tipText === null ? tips[Math.floor(Math.random() * tips.length)] : null);
			}, tipText === null ? INVISIBLE_TIME : READING_TIME);
			return () => clearInterval(interval);
		}
	}, [tipText, children, soundEnabled]);

	return <div
		className={`tipbubble bg-white rounded-full mx-auto shadow-md py-2 px-4 transition-all select-none z-10 ${className}`}
		style={{
			transform: children ? 'scale(1)' : (tipText ? 'scale(1)' : 'scale(0)'),
			animation: animated ? 'tipbubble 3s ease-in-out infinite' : 'none',
		}}>
		{children || <>Probeer eens... <span className="font-bold">{tipText}!</span></>}
	</div>;
};

TipBubble.propTypes = {
	animated: PropTypes.bool,
	children: PropTypes.any,
	className: PropTypes.string,
	soundEnabled: PropTypes.bool
}

TipBubble.defaultProps = {
	animated: undefined,
	children: undefined,
	className: undefined,
	soundEnabled: false
}

export default TipBubble;
